// config.js
// Change API_BASE_URL for different environments

export const API_BASE_URL = 'https://ganotras.in/neebunServer';
export const DEMOLINK = 'https://demosw.ganotras.in/';  
